// extracted by mini-css-extract-plugin
export default {"title":"styles_title__XmLyI","title2":"styles_title2__6iGu+","text1":"styles_text1__CWE7-","text2":"styles_text2__hWvLM"};